// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin-top: 70px;
  height: 700px;
  display: flex;
  align-items: center;
  padding-bottom: 200px;
  flex-direction: column;
  justify-content: space-between;
  background-image: linear-gradient(to bottom, #ffffff, #f4f5fa);
}
.banner {
  width: 675px;
  display: flex;
  justify-content: space-between;
}
.banner .bannerMain {
  color: #404040;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.banner .bannerMain .name {
  font-size: 30px;
  line-height: 1.5;
  letter-spacing: 6px;
  color: rgba(0, 0, 0, 0.85);
}
.banner .bannerMain .slogan {
  margin: 0;
  font-size: 30px;
  line-height: 1.5;
  white-space: nowrap;
  font-weight: 300;
  letter-spacing: 6px;
}
.videoBoard {
  width: 900px;
  height: 360px;
  display: flex;
  box-shadow: 0 -5px 20px 0 rgba(0, 0, 0, 0.05);
}
.videoBoard .fakeChatInboxWrapper {
  width: 277px;
  flex-shrink: 0;
}
.videoBoard .fakeChatInboxWrapper .fakeChatInbox {
  width: 100%;
  height: auto;
}
.videoBoard .videoSubBoard {
  display: flex;
  align-items: flex-start;
  margin-left: -2px;
  flex-direction: column;
  background-color: #f7f7f7;
}
.videoBoard .videoSubBoard .fakeChatHeader {
  width: 624px;
  height: auto;
}
.videoBoard .videoSubBoard .video {
  height: 300px;
  margin-left: 20px;
}
.Header {
  width: 100% !important;
  padding: 0 30px;
  display: flex !important;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.03);
  z-index: 999 !important;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: white;
  z-index: 1000;
}
.Header .u-container {
  max-width: 1200px;
  width: 100% !important;
  justify-content: center !important;
}
.Header .Header-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100%;
  margin: 20px 90px;
}
.Header .Header-logo .Headerlogo {
  height: 100%;
  margin-right: 30px;
}
.Header-shadow {
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
}
.content_didi {
  text-decoration: none;
  color: #545763;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/views/mainPage/Header/style.less"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,8BAAA;EACA,8DAAA;AACJ;AACA;EACI,YAAA;EACA,aAAA;EACA,8BAAA;AACJ;AAJA;EAKQ,cAAA;EAEA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;AACR;AAXA;EAYY,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAEZ;AAjBA;EAkBY,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAEZ;AAEA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,6CAAA;AAAJ;AAJA;EAMQ,YAAA;EACA,cAAA;AACR;AARA;EASY,WAAA;EACA,YAAA;AAEZ;AAZA;EAcQ,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AACR;AAnBA;EAoBY,YAAA;EACA,YAAA;AAEZ;AAvBA;EAwBY,aAAA;EACA,iBAAA;AAEZ;AAEA;EACI,sBAAA;EACA,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;AAAJ;AAXA;EAaQ,iBAAA;EACA,sBAAA;EACA,kCAAA;AACR;AAhBA;EAkBQ,eAAA;EACA,aAAA;EAEA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yDAAA;EACA,qBAAA;EACA,iBAAA;AAAR;AA1BA;EA4BY,YAAA;EACA,kBAAA;AACZ;AAGA;EACI,yCAAA;AADJ;AAGA;EACI,qBAAA;EACA,cAAA;EACA,eAAA;AADJ","sourcesContent":[".container{\n    margin-top: 70px;\n    height: 700px;\n    display: flex;\n    align-items: center;\n    padding-bottom: 200px;\n    flex-direction: column;\n    justify-content: space-between;\n    background-image: linear-gradient(to bottom, #ffffff, #f4f5fa);\n}\n.banner {\n    width:675px;\n    display: flex;\n    justify-content: space-between;\n    .bannerMain{\n        color: #404040;\n        // padding-top: 20px;\n        display: flex;\n        align-items: flex-start;\n        flex-direction: column;\n        justify-content: center;\n        .name{\n            font-size: 30px;\n            line-height: 1.5;\n            letter-spacing: 6px;\n            color: rgba(0, 0, 0, 0.85);\n        }\n        .slogan{\n            margin: 0;\n            font-size: 30px;\n            line-height: 1.5;\n            white-space: nowrap;\n            font-weight: 300;\n            letter-spacing: 6px;\n        }\n    }\n}\n.videoBoard{\n    width: 900px;\n    height: 360px;\n    display: flex;\n    box-shadow: 0 -5px 20px 0 rgba(0, 0, 0, 0.05);\n    .fakeChatInboxWrapper{\n        width: 277px;\n        flex-shrink: 0;\n        .fakeChatInbox{\n            width: 100%;\n            height: auto;\n        }\n    }\n    .videoSubBoard{\n        display: flex;\n        align-items: flex-start;\n        margin-left: -2px;\n        flex-direction: column;\n        background-color: #f7f7f7;\n        .fakeChatHeader{\n            width: 624px;\n            height: auto;\n        }\n        .video{\n            height: 300px;\n            margin-left: 20px;\n        }\n    }\n}\n.Header{\n    width: 100% !important;\n    padding: 0 30px;\n    display: flex !important;\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.03);\n    z-index: 999 !important;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: white;\n    z-index: 1000;\n    .u-container{\n        max-width: 1200px;\n        width: 100% !important;\n        justify-content: center !important;\n    }\n    .Header-logo {\n        cursor: pointer;\n        display: flex;\n        // width: 78px;\n        align-items: center;\n        justify-content: center;\n        height: 28px;\n        background-image:url('../images/logo.png');\n        background-size: 100%;\n        margin:20px 90px;\n        .Headerlogo{\n            height: 100%;\n            margin-right: 30px;\n        }\n      }\n}\n.Header-shadow {\n    box-shadow: 0 0 12px 0 rgba(0, 0, 0, .1);\n  }\n.content_didi{\n    text-decoration:none;\n    color: #545763;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
